// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2EHv7","rootMobile":"styles_rootMobile__Px1_A"};